<template>
  <div class="col-md-12">
    <div v-if="currentUser" class="card card-container">
      <h4><font-awesome-icon icon="edit" /> Change Password</h4>
      <form name="form" @submit.prevent="changePassword">
        <div v-if="!successful">
          <input v-model="currentUser.staffNo" type="hidden" id="staffNo" name="staffNo">
          <input v-model="currentUser.firstName" type="hidden" id="firstName" name="firstName">
          <input v-model="currentUser.lastName" type="hidden" id="lastName" name="lastName">
          <input v-model="currentUser.username" type="hidden" id="username" name="username">
          <input v-model="currentUser.email" type="hidden" id="email" name="email">
          <input v-model="currentUserTypeCode" type="hidden" id="currentUserTypeCode" name="currentUserTypeCode">
          <div class="form-group">
            <label for="username">New Password:</label>
            <input v-model="newPassword" v-validate="'required|min:6|max:999'" type="password" class="form-control" id="newPassword" name="newPassword"/>
            <div v-if="submitted && errors.has('newPassword')" class="alert-danger">{{errors.first('newPassword')}}</div>
          </div>
          
          <div class="form-group">
            <button type="submit" class="badge badge-success mr-2"><font-awesome-icon icon="save" /> Change</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      
    </div>
    <div v-else>
      <br />
      <p>Please click on a User...</p>
    </div>
  </div>
</template>

<script>
import UserService from "../services/user.service";

export default {
  name: 'user',
  data() {
    return {
      currentUser: null,
      submitted: false,
      successful: false,
      message: '',
      currentUserTypeCode: '',
      currentUserTypeName: '',
      newPassword: '',
      typeSet: new Set(),
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    getUser(id) {
      UserService.get(id)
        .then(response => {
          this.currentUser = response.data;
          console.log(response.data);
          for(let userRole of this.currentUser.roles) {
            console.log(userRole.name);
            if(userRole.name=='ROLE_USER'){
              this.currentUserTypeCode = 'mem';
              this.currentUserTypeName = 'Member';
              break;
            }
            if(userRole.name=='ROLE_MANAGER'){
              this.currentUserTypeCode = 'man';
              this.currentUserTypeName = 'Manager';
              break;
            }
            if(userRole.name=='ROLE_AUDITOR'){
              this.currentUserTypeCode = 'aud';
              this.currentUserTypeName = 'Auditor';
              break;
            }
            if(userRole.name=='ROLE_ADMIN'){
              this.currentUserTypeCode = 'admin';
              this.currentUserTypeName = 'Admin';
              break;
            }
            if(userRole.name=='ROLE_SUPERADMIN'){
              this.currentUserTypeCode = 'super';
              this.currentUserTypeName = 'Super Admin';
              break;
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    changePassword() {
      this.message = '';
      this.submitted = true;
      this.currentUser.userType = this.currentUserTypeCode;
      this.currentUser.password = this.newPassword;
      this.currentUser.newPassword = this.newPassword;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          UserService.changePassword(this.currentUser.username, this.currentUser).then(
            response => {
              console.log(response.data);
              this.message = 'Your password was updated successfully!';
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log(e);
            });
        }
      });
    },
    
  },
  mounted() {
    this.message = '';
    this.getUser(this.$route.params.id);
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>